module.exports = __webpack_public_path__ + "static/media/hackerrank_logo.7c0d9329.png";